import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterReminderType,
  TAdvancedFilterSingle,
  TFilterReminderTypeOptions,
} from '../../../../models/advanced-filter.model';
import { getAdvancedReminderTypeOptions } from './get-advanced-reminder-type-options';

@Component({
    selector: 'pp-advanced-filter-reminder-type',
    templateUrl: './advanced-filter-reminder-type.component.html',
    styleUrl: './advanced-filter-reminder-type.component.scss',
    standalone: false
})
export class AdvancedFilterReminderTypeComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterReminderTypeOptions;
  filter: TAdvancedFilterReminderType;

  advancedFilterReminderTypeOptions = getAdvancedReminderTypeOptions();
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterReminderType;

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterReminderTypeOptions;
    this.option = newCondition.value as TFilterReminderTypeOptions;
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
